<mat-list>
  <mat-list-item
    matRipple
    [matRippleDisabled]="disabled"
    class="select-trigger cursor-pointer"
    (click)="disabled ? null : select.emit($event)"
  >
    {{ label }}
    <mat-icon *ngIf="icon" matListIcon>{{ icon }}</mat-icon>
  </mat-list-item>
</mat-list>
